import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";
import Spinner from "react-bootstrap/Spinner";
import Button from "react-bootstrap/Button";
import "./Gallery.css";

export default function ProductList() {
    const [products, setProducts] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        fetch("https://vimaljewellery.com/api/v1/admin/product/product-lists")
            .then((response) => response.json())
            .then((data) => {
                if (Array.isArray(data) && data.length > 0) {
                    setProducts(data);
                    setLoading(false); // Only stop loading when valid data is received
                } else {
                    console.warn("No products found or invalid response");
                    // Keep spinner on
                }
            })
            .catch((error) => {
                console.error("Error fetching products:", error);
                // Keep spinner on
            });
    }, []);
    
    // Framer Motion animation variants
    const containerVariants = {
        hidden: { opacity: 0 },
        visible: {
            opacity: 1,
            transition: {
                staggerChildren: 0.2,
            },
        },
    };

    const cardVariants = {
        hidden: { opacity: 0, y: 20 },
        visible: { opacity: 1, y: 0, transition: { duration: 0.5 } },
        hover: {
            scale: 1.05,
            boxShadow: "0 8px 16px rgba(0, 0, 0, 0.3)",
            transition: { duration: 0.3 },
        },
    };

    const textVariants = {
        hidden: { opacity: 0, x: -20 },
        visible: { opacity: 1, x: 0, transition: { duration: 0.5 } },
    };

    const buttonVariants = {
        hover: {
            scale: 1.1,
            backgroundColor: "#0056b3",
            transition: { duration: 0.3 },
        },
    };

    return (
        <motion.section
            className="shop-container"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 1 }}
        >
            <h3 style={{ color: "black", fontWeight: "450px" }}></h3>
    
            {loading ? (
                <div style={{ textAlign: "center", padding: "40px 0" }}>
                    <Spinner animation="border" variant="primary" className="mx-2" />
                    <Spinner animation="grow" variant="dark" className="mx-2" />
                    <Spinner animation="border" variant="success" className="mx-2" />
                    <Spinner animation="grow" variant="danger" className="mx-2" />
                    <Spinner animation="border" variant="danger" className="mx-2" />
                    <Spinner animation="grow" variant="warning" className="mx-2" />
                </div>
            ) : (
                <motion.div
                    className="product-grid"
                    variants={containerVariants}
                    initial="hidden"
                    animate="visible"
                >
                    {products.map((product) => (
                        <motion.div
                            key={product.id}
                            className="product-card"
                            variants={cardVariants}
                            whileHover="hover"
                            whileTap={{ scale: 0.95 }}
                        >
                            <motion.img
                                src={
                                    product.productImage?.imageByte
                                        ? `data:${product.productImage.imageType};base64,${product.productImage.imageByte}`
                                        : "/placeholder.png"
                                }
                                alt={product.productName}
                                className="product-image1"
                                whileHover={{ scale: 1.1 }}
                                transition={{ duration: 0.3 }}
                            />
                            <motion.h3 className="product-name" variants={textVariants}>
                                {product.productName}
                            </motion.h3>
                            <motion.div className="product-info" variants={textVariants}>
                                <p className="product-price">₹ {product.productPrice}</p>
                                <p className="product-weight">{product.productWeight} grams</p>
                            </motion.div>
                            <motion.button
                                className="buy-now-btn"
                                variants={buttonVariants}
                                whileHover="hover"
                            >
                                Buy Now
                            </motion.button>
                        </motion.div>
                    ))}
                </motion.div>
            )}
        </motion.section>
    );
    
}
